; (function ($, window, document) {

    "use strict";

    $(document).ready(function () {

        var triggerVideo = $('[trigger-video]');

        if (triggerVideo) {
            $(triggerVideo).magnificPopup({
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false
            });
        }
    });

})(jQuery, window, document);
